import React from "react"

function ChevronRightIcon() {
    return (
        <svg width="10" height="16" viewBox="0 0 10 16" fill="inherit" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2L2.038 0L10 8L2.038 16L0 14L6 8L0 2Z" />
        </svg>
    )
}

export default ChevronRightIcon
